var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 68,
    fill: "#B4FFA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9717 31C97.143 31.0001 108.229 39.9907 108.229 57.9717C108.228 67.1906 105.257 74.0858 99.3144 78.6572C93.4478 83.2286 85.3335 85.5146 74.9717 85.5146H68.3428V111H40V31H74.9717Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.66 51.385C82.3193 49.7258 86.2002 47.7452 87.7932 49.3381C89.386 50.931 88.2013 55.3807 86.4285 57.1535C84.6558 58.9262 81.9274 59.072 80.3344 57.479C78.7415 55.8861 78.8873 53.1577 80.66 51.385Z",
    fill: "#B4FFA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1088 72.5036C69.7355 72.3086 68.6424 71.4297 67.889 70.3476C67.1355 69.2654 66.6783 67.9817 66.202 66.7227C66.1989 66.7147 66.1959 66.7066 66.193 66.6988C65.6126 65.1663 64.4022 63.9559 62.8699 63.3754C62.8616 63.3723 62.8535 63.3691 62.8454 63.3661C61.5865 62.89 60.3027 62.4326 59.2207 61.6792C58.1386 60.9259 57.2595 59.8326 57.0647 58.4595C56.8696 57.0863 57.4831 55.4207 58.7527 54.536C59.9201 53.7228 61.3571 53.7025 62.6138 53.9006C63.8706 54.0988 65.0965 54.4784 66.418 54.3328C67.7806 54.1828 69.1119 53.4881 70.4711 53.1342C70.4913 53.1289 70.5118 53.1236 70.5325 53.1184C74.098 52.224 77.3443 55.4702 76.4498 59.0356C76.4445 59.0564 76.4392 59.0768 76.4341 59.0971C76.0801 60.4564 75.3853 61.7875 75.2353 63.1501C75.0898 64.4717 75.4695 65.6977 75.6677 66.9545C75.8657 68.2111 75.8454 69.6482 75.0322 70.8155C74.1474 72.0851 72.4819 72.6987 71.1088 72.5036Z",
    fill: "#B4FFA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7135 51.066C61.9248 50.2944 61.1711 48.0553 62.0298 46.0647C62.8884 44.0742 66.0861 41.7015 67.8747 42.4731C69.6634 43.2447 69.3106 46.9958 68.5069 48.8588C67.6482 50.8495 65.5022 51.8376 63.7135 51.066Z",
    fill: "#B4FFA0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7856 43.5105C74.5584 41.7377 79.0081 40.553 80.6009 42.1458C82.1939 43.7388 80.2133 47.6197 78.554 49.279C76.7813 51.0517 74.053 51.1975 72.46 49.6045C70.867 48.0116 71.0129 45.2832 72.7856 43.5105Z",
    fill: "#B4FFA0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8744 67.9093C81.8838 68.7678 79.6446 68.0142 78.873 66.2255C78.1014 64.4369 79.0895 62.2908 81.0802 61.4321C82.9433 60.6284 86.6943 60.2757 87.4659 62.0643C88.2375 63.8529 85.8648 67.0506 83.8744 67.9093Z",
    fill: "#B4FFA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.ee90ec3d46f02a0c93935c6ae0e2860c.svg";
export { ForwardRef as ReactComponent };